module.exports = "/shared/img/fast-btn-up.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/img/fast-btn-up.png
// module id = 9
// module chunks = 13